var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPlanVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.987,
    height: 26.918,
    viewBox: "0 0 36.987 26.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M923.1,385.021c0-1.471,0-2.942,0-4.413a2.3,2.3,0,0,1,3.53-2.165c2.921,1.5,5.835,3.005,8.756,4.5a2.318,2.318,0,0,1,0,4.242c-2.921,1.5-5.862,2.955-8.745,4.521a2.367,2.367,0,0,1-3.546-2.189C923.131,388.019,923.1,386.52,923.1,385.021Z",
    transform: "translate(-910.784 -371.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.2,376.369a18.088,18.088,0,0,1,5.282-12.474,1.34,1.34,0,0,1,1.972-.159,1.321,1.321,0,0,1-.059,1.977A15.176,15.176,0,0,0,898.322,373a15.621,15.621,0,0,0,3.793,14.654c.128.143.272.274.4.42a1.317,1.317,0,0,1-1.924,1.8,18.262,18.262,0,0,1-4.393-7.038A19.557,19.557,0,0,1,895.2,376.369Z",
    transform: "translate(-895.197 -363.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.319,377.482A17.993,17.993,0,0,1,964,389.805a1.323,1.323,0,1,1-1.884-1.844,15.287,15.287,0,0,0,4.259-8.086,15.6,15.6,0,0,0-4.036-13.947c-.083-.091-.173-.176-.257-.267a1.321,1.321,0,1,1,1.894-1.837,18.2,18.2,0,0,1,3.95,5.934A19.409,19.409,0,0,1,969.319,377.482Z",
    transform: "translate(-932.332 -363.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.358,381.273a12.817,12.817,0,0,1,3.711-8.777,1.34,1.34,0,0,1,1.97-.162,1.323,1.323,0,0,1-.055,1.976,10.494,10.494,0,0,0-.106,14.531,1.563,1.563,0,0,1,.569,1.226,1.254,1.254,0,0,1-.866,1.147,1.279,1.279,0,0,1-1.43-.352,13.021,13.021,0,0,1-2.841-4.3A13.7,13.7,0,0,1,907.358,381.273Z",
    transform: "translate(-901.992 -368.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.168,381.337a13.269,13.269,0,0,1-3.683,9.394,1.336,1.336,0,1,1-1.9-1.833,10.471,10.471,0,0,0,.387-14.119c-.169-.2-.359-.38-.531-.577a1.317,1.317,0,1,1,1.9-1.819,12.805,12.805,0,0,1,3.639,7.153C959.092,380.228,959.128,380.93,959.168,381.337Z",
    transform: "translate(-927.532 -368.171)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlanVideo);
export default __webpack_public_path__ + "static/media/ICO-PLAN-VIDEO.9d4131f06fc54082ecd6c11470e11edd.svg";
export { ForwardRef as ReactComponent };